export default __webpack_public_path__ + "static/media/ProgrammableSplitter.256.b3ca3142.png";